import { useTranslation } from 'react-i18next'

export const TableActionColumnTitle = () => {
  const { t } = useTranslation()

  return <span className="action-column-title">{t('actions')}</span>
}
